import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import fingerPrintIcon from "images/security-page/secure-fingerprint.png";
import paymentPrivacyIcon from "images/security-page/payment-privacy.png";
import riskAssesmentIcon from "images/security-page/risk-assessment.png";
import partnersInProtectionIcon from "images/security-page/partners-in-protection.png";
import rightFlowerArtImg from "images/security-page/flower-right.png";
import leftFlowerArtImg from "images/security-page/flower-right.png";

import "./SafetyFirstSummary.css";

const SafetyFirstSummary = () => {
    return (
        <WidgetContainer stylesClass="safety-first">
            <div className="safety-first__container">
                <img
                    src={rightFlowerArtImg}
                    className="right-flower"
                    draggable="false"
                />
                <img
                    src={leftFlowerArtImg}
                    className="left-flower"
                    draggable="false"
                />

                <h1>Your safety comes first</h1>
                <div className="safety-first__container_cards">
                    <div className="safety-first__container_cards__item">
                        <img
                            src={fingerPrintIcon}
                            width="80"
                            draggable="false"
                        />
                        <h3>Secure from the start </h3>
                        <p>
                            Every transaction on PhonePe needs your
                            fingerprint/face ID, UPI PIN and password for
                            authentication.
                        </p>
                    </div>
                    <div className="safety-first__container_cards__item">
                        <img
                            src={paymentPrivacyIcon}
                            width="80"
                            style={{ marginLeft: "-4px" }}
                            draggable="false"
                        />
                        <h3>Payment Privacy</h3>
                        <p>
                            Only you and the person you are transacting with
                            will be able to see the details of your payment.
                        </p>
                    </div>
                    <div className="safety-first__container_cards__item">
                        <img
                            src={riskAssesmentIcon}
                            width="80"
                            draggable="false"
                        />

                        <h3>Risk assessment</h3>
                        <p>
                            Our security teams monitor all transactions in
                            real-time to block any suspicious activity. We also
                            report fraud complaints &amp; block fraudulent users
                            from accessing the PhonePe platform
                        </p>
                    </div>
                    <div className="safety-first__container_cards__item">
                        <img
                            src={partnersInProtectionIcon}
                            width="80"
                            draggable="false"
                        />
                        <h3>Partners in protection</h3>
                        <p>
                            To aid safe transactions, we have partnered with
                            cyber-crime cells of government law enforcement and
                            security agencies, such as National Cybercrime
                            Portal, CyCord and CyberSafe.
                        </p>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default SafetyFirstSummary;
